import {initArrivalDatepickers} from '../shared/datepickers';

export function initEnquiryForms(root, config) {
    root.querySelectorAll('[data-chalet-enquiry-form]').forEach(form => {
        initArrivalDatepickers(form, {onChange: (date, event, input) => { input.value = date; }});
        const expand = form.querySelector('[data-enquiry-expand]');
        expand?.addEventListener('click', () => {
            const active = form.classList.toggle('active');
            expand.setAttribute('aria-expanded', String(active));
        });
        // Match the Vue form: display validation returned by the enquiry endpoint.
        form.noValidate = true;
        let busy = false;
        const hash = [...crypto.getRandomValues(new Uint8Array(16))].map(byte => byte.toString(16).padStart(2, '0')).join('');
        const errors = form.querySelector('[data-enquiry-errors]');
        async function post(url, data) {
            const response = await fetch(url, {
                method: 'POST', credentials: 'same-origin',
                headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-CSRF-TOKEN': form.elements._token.value},
                body: JSON.stringify(data),
            });
            const body = await response.json();
            if (!response.ok) throw body;
            return body.data || body;
        }
        form.addEventListener('submit', async event => {
            event.preventDefault();
            if (busy) return;
            busy = true;
            const button = form.querySelector('[type="submit"]');
            button.disabled = true;
            form.setAttribute('aria-busy', 'true');
            errors.hidden = true;
            errors.replaceChildren();
            form.querySelectorAll('.parsley-error').forEach(field => { field.classList.remove('parsley-error'); field.removeAttribute('aria-invalid'); });
            const attributes = Object.fromEntries(new FormData(form));
            delete attributes._token;
            attributes.hash = hash;
            attributes.gclid = document.cookie.split('; ').find(cookie => cookie.startsWith('gclid='))?.slice(6);
            try {
                await post(config.enquiryUrl, attributes);
                window.location.assign(config.thankYouUrl);
            } catch (error) {
                const validation = error.errors || {};
                Object.keys(validation).forEach(name => {
                    const field = form.elements.namedItem(name);
                    if (field) { field.classList.add('parsley-error'); field.setAttribute('aria-invalid', 'true'); }
                });
                const messages = Object.values(validation).flat();
                if (!messages.length) messages.push(error.message || 'We could not submit your enquiry. Please try again.');
                messages.forEach(message => {
                    const line = document.createElement('div');
                    line.textContent = message;
                    errors.appendChild(line);
                });
                errors.hidden = false;
            } finally {
                busy = false;
                button.disabled = false;
                form.removeAttribute('aria-busy');
            }
        });
    });
}
